(function(SCS) {
	'use strict';

	SCS.search = SCS.search || {};
	SCS.search.util = SCS.search.util || {};

	var util = SCS.search.util;

	var slice = Array.prototype.slice;

	function respondOnce(targetEvents, callback, context) {
		if(!util.isArray(targetEvents)) {
			targetEvents = [targetEvents];
		}
		var result = function onceResponder(event, processor) {
			if(util.inArray(event, targetEvents) === -1) {
				return;
			}
			processor.removeResponder(onceResponder);
			callback.apply(context||this, arguments);
		};
		result.displayName = result.name + ' (' + targetEvents + '): ' + callback.name;
		return result;
	}

	function respondTo(events, context) {
		var result = function toResponder(event) {
			if(event in events) {
				var args = slice.call(arguments, toResponder.length);
				events[event].apply(context||this, args);
			}
		};
		result.displayName = result.name + ': ' + (Object.keys ? Object.keys(events) : 'events');
		return result;
	}

	util.respondOnce = respondOnce;
	util.respondTo = respondTo;

})(window.SCS = window.SCS || {});


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/util/responders.js
// module id = 40
// module chunks = 0